import React from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { addFavourite, removeFavourite } from '../../Components/redux/favouritesSlice';
import { useNavigate } from 'react-router-dom';


const ProductCard = ({ index, name, id, description, image1, isNew, colors, nameEn, isBestseller, discount }) => {

      const { t, i18n } = useTranslation();
      const currentLanguage = i18n.language; // Aktif dili alıyoruz
      const navigate = useNavigate();
        const dispatch = useDispatch();

        const getLocalizedValue = (base, baseEn, baseRu) => {
    if (currentLanguage === 'en') return baseEn;
    if (currentLanguage === 'ru') return baseRu;
    return base;
  };

     const favourites = useSelector((state) => state.favourites.items);

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase];
    return item[fieldBase];
  };

  const userId = useSelector((state) => state.user.id);

  
    const isFavourite = (id) => favourites.includes(Number(id));
  
    const toggleFavourite = async (productId) => {
       // Kullanıcı giriş yapmamışsa uyarı göster ve devam etme
                         if (!userId) {
                           navigate(`/${currentLanguage}/login`);
                           toast.error(t("Zəhmət olmasa giriş edin"));
                           return;
                         }
                       
                         if (!productId) return;
                   
      
  
      try {
        if (isFavourite(productId)) {
          dispatch(removeFavourite(productId));
          await axios.delete("https://www.elzabeauty.az/elza/favourites.php", {
            data: new URLSearchParams({
              user_id: userId,
              product_id: productId,
            }),
          });
          toast.error(t("Sevimlilərdən çıxarıldı"));
        } else {
          dispatch(addFavourite(productId));
          await axios.post(
            "https://www.elzabeauty.az/elza/favourites.php",
            new URLSearchParams({ user_id: userId, product_id: productId })
          );
          toast.success(t("Sevimlilərə əlavə olundu"));
        }
      } catch (error) {
        console.error("Favori güncelleme hatası:", error);
      }
    };

  return (
    <a href={`/${currentLanguage}/product-detail/${id}`}>
      <div className='bg-white rounded-[8px] w-full md:w-[289px] min-h-[330px] mx-auto p-5 shadow-md group relative'>
       {(isNew === 1 || isBestseller === 1 || discount > 0) && (
  <div className="absolute top-3 left-3 bg-[#E497BB] text-[white] text-[12px] font-medium px-2 py-1 rounded z-10">
    {isNew === 1
      ? t("Yeni")
      : isBestseller === 1
      ? t("Ən çox satılanlar")
      : discount > 0
      ? `- ${discount} %` 
      : null}
  </div>
)}
<div className="absolute top-0 right-0 z-10">
              <div
  onClick={(e) => {
    e.preventDefault();
    toggleFavourite(id);
  }}
  role="button"
  tabIndex={0}
  aria-label={
    isFavourite(id)
      ? t("Favorilerden çıkar")
      : t("Favorilere ekle")
  }
  className="absolute top-3 right-3 z-10 text-[24px] cursor-pointer select-none"
     style={{ color: isFavourite(id) ? 'red' : 'gray' }}
>
  {isFavourite(id) ? '❤️' : '🤍'}
</div>

              </div> 


        <div className='text-[#0B0B0B]'>
          <div className='bg-white h-[224px] flex justify-center items-center relative overflow-hidden'>
            <img
              className='w-full h-full transition-all duration-300 group-hover:scale-110 object-cover'
              src={`https://www.elzabeauty.az/elza/${image1}`}
              alt={name || 'Product image'}
            />
          </div>
          <p className='font-medium mt-5 text-[#121212]'>
            {getLocalizedValue(name, nameEn)}
          </p>

          {/* Renk kutuları */}
           <div className="flex gap-2 mt-3">
           {colors?.map((colorItem, index) => (
  <div
    key={index}
    className="w-7 h-7 flex items-center justify-center rounded-full border border-[#838383] bg-white"
    title={getLocalizedField(colorItem, "name")}
  >
    <div
      className="w-5 h-5 rounded-full"
      style={{ backgroundColor: colorItem.code }}
    ></div>
  </div>
))}

          </div>
        </div>
      </div>
    </a>
  );
};

export default ProductCard;
